<template>
  <!--
    name: 覃刚
    function: 原料数据库-新增
    date: 2021-03-15
 -->
  <div class="modalBox">
    <div class="nurientHead">
      <div style="position: relative; margin-right: 20px">
        <!-- <a-input-search v-model="formData.keyword" placeholder="原料名称/代码" @search="onSearch">
          <a-button slot="enterButton">
            搜索
          </a-button>
        </a-input-search> -->

        <!-- <a-icon type="search" style="
            position: absolute;
            left: 183px;
            top: 5px;
            z-index: 1000;
            color: #ccc;
          " @click="onSearch" />
        <a-select allowClear show-search :placeholder="placeStr" class="productSelect"
          :default-active-first-option="false" style="width: 200px" :show-arrow="false" :filter-option="false"
          :not-found-content="null" @search="(e) => getSearchList(e)" @select="onSearch" @inputKeydown="inputKeydown"
          v-model="formData.keyword">
          <a-select-option v-for="d in searchList" :key="d.code">
            {{ d.firstName }}<span style="color: red">{{ d.midName }}</span>{{ d.lastName }}({{ d.code }})
          </a-select-option>
        </a-select> -->
        <a-input style="width: 200px" :placeholder="placeStr" v-model="formData.keyword"
          @change="searchInput"></a-input>
        <!-- <a-button @click="onSearch">
            搜索
          </a-button> -->
      </div>
<!--      <div class="middle"></div>-->
      <div style="display: flex">
        <a-select v-model="status" placeholder="请选择原料状态" @change="onSearch" style="width: 180px; margin-right: 20px"
          allowClear>
          <a-select-option :value="0">激活</a-select-option>
          <a-select-option :value="1">失效</a-select-option>
        </a-select>

        <a-cascader v-model="typeArr" :options="typeList" :load-data="loadData" placeholder="请选择类型" change-on-select
          style="width: 180px" @change="changeType" />
        <a-checkbox v-model="storageWeightCond" @change="storageWeightCondChange" style="width: 180px; margin-left: 20px">只查看有库存的原料</a-checkbox>
        <!-- <a-select v-model="priceField" style="width: 120px">
          <a-select-option value="privateContractPrice">
            合同价格
          </a-select-option>
          <a-select-option value="privateStockPrice">
            库存价格
          </a-select-option>
          <a-select-option value="privateMarketPrice">
            市场价格
          </a-select-option>
          <a-select-option value="privatePredictionPrice">
            预测价格
          </a-select-option>
        </a-select> -->
      </div>
    </div>
    <a-table bordered :scroll="{ x: 100, y: 300 }" :columns="columns" :data-source="list" class="tableBox"
      :row-selection="rowSelection" :pagination="pagination" rowKey="id" :customRow="customRow">

      <span slot="sort" slot-scope="t, r, index">{{ index + 1 }}</span>

      <span slot="price" slot-scope="t, record">{{ record[priceField] }}</span>

      <a-tooltip slot="tips" slot-scope="t">
        <template slot="title">{{ t }}</template>
        {{ t }}
      </a-tooltip>

      <template slot="fixed3" slot-scope="t">{{
        t || t === 0 ? Number(t).toFixed(3) : t
      }}</template>

      <template slot="typeName" slot-scope="text, record">
        <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record)">
          <template slot="title">
            {{ record.fullTypeName }}
          </template>
          <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
        </a-tooltip>
      </template>

      <div slot="status" slot-scope="text, record">
        <span :style="{ color: !text ? 'green' : 'red' }">{{
          !text ? "激活" : "失效"
        }}</span>/{{ record.categoryTypeName ? record.categoryTypeName : "-" }}
      </div>

      <template slot="turnoverDayTitle">
        <label>可耗用天数</label>
        <a-tooltip style="position: relative;top: 1px;margin-left: 4px">
          <template slot="title">期末库存量/近30日平均耗用量</template>
          <a-icon type="exclamation-circle" />
        </a-tooltip>
      </template>

      <template slot="turnoverDay" slot-scope="text, record">
        <a-tooltip v-if="turnoverDayTip(record)" style="margin-right: 4px;">
          <template slot="title">
            高库存原料：{{ record.purchaseClass + ' > ' + (record.purchaseClassCode === '1001' ? '15' : '30') }}天
          </template>
          <a-icon type="info-circle" style="color: orange;" />
        </a-tooltip>
        <label :style="{ color: turnoverDayTip(record) ? 'orange' : '' }">{{ text }}</label>
      </template>
    </a-table>

    <div class="selectCount">
      已选中
      <span class="colorRed">{{ this.selectedIdList.length || 0 }}</span> 个原料
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  props: {
    typeList: Array,
    default: () => {
      return [];
    }
  },
  data() {
    return {
      keyword: '',
      placeStr: '原料名称/代码',
      searchList: [],
      name: 'ddd',
      typeArr: [],
      status: undefined,
      storageWeightCond: false,
      priceField: 'privateMarketPrice',
      form: this.$form.createForm(this, {
        note: 'dddd',
        gender: 1
      }),
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.getList({ current, pageSize });
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1;
          this.pagination.pageSize = pageSize;
          this.getList({ current: 1, pageSize });
        } //每页多少条
      },
      formData: {
        keyword: undefined,
        typeid: '',
        price: ''
      },
      selectedIdList: [],
      selectedRows: [],
      list: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          width: 40,
          ellipsis: true,
        },
        {
          title: '原料名称',
          dataIndex: 'name',
          ellipsis: true,
          width: 160,
          scopedSlots: { customRender: 'tips' },
        },
        {
          title: '代码',
          dataIndex: 'code',
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: 'tips' },
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          minWidth: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'typeName' },
        },
        // {
        //   title: '市场价格',
        //   dataIndex: 'privateMarketPrice',
        //   width: 100,
        //   ellipsis: true,
        // },
        // {
        //   title: '库存价格',
        //   dataIndex: 'privateStockPrice',
        //   width: 100,
        //   ellipsis: true,
        // },
        // {
        //   title: '合同价格',
        //   dataIndex: 'privateContractPrice',
        //   width: 100,
        //   ellipsis: true,
        // },
        // {
        //   title: '预测价格',
        //   dataIndex: 'privatePredictionPrice',
        //   width: 100,
        //   ellipsis: true,
        // },

        {
          title: "库存量",
          dataIndex: "storageWeight",
          minWidth: 40,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "fixed3" },
        },
        {
          title: "单位",
          dataIndex: "unit",
          minWidth: 40,
          ellipsis: true,
        },
        {
          title: '状态/类目归属',
          dataIndex: 'status',
          minWidth: 120,
          scopedSlots: { customRender: 'status' }
        },
        {
          // title: "可耗用天数",
          dataIndex: "turnoverDay",
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { title: 'turnoverDayTitle', customRender: "turnoverDay" },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          minWidth: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'tips' },
        }
      ]
    };
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys) => {
          this.selectedIdList = selectedRowKeys;
        },
        onSelect: (record, selected) => {
          if (selected) {
            this.selectedRows.push(record);
          } else {
            this.selectedRows = this.selectedRows.filter(el => el.id !== record.id);
          }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          if (selected) {
            changeRows.forEach((el) => {
              if (
                  this.selectedRows.length < 20 &&
                  !this.selectedRows.includes(el.id)
              ) {
                this.selectedRows.push(el);
              }
            });
          } else {
            let ids = changeRows.map(el => el.id);
            this.selectedRows = this.selectedRows.filter(el => !ids.includes(el.id));
          }
        },
        selectedRowKeys: this.selectedIdList,
        getCheckboxProps: record => ({
          props: {
            disabled: record.chooseStatus === '1'
          },
        }),
      };
    }
  },
  created() {
    this.getList();
  },
  methods: {
    customRow(record) {
      return {
        on: {
          dblclick: () => {
            if (this.selectedIdList.includes(record.id)) {
              this.selectedIdList = this.selectedIdList.filter(el => el !== record.id);
            } else {
              this.selectedIdList.push(record.id);
            }
          }
        }
      };
    },
    onBlur() {
      this.keyword = '';
    },
    inputKeydown(e) {
      if (e.keyCode === 13) this.getList({ current: 1, pageSize: 20 });
    },
    getSearchList(keyword) {
      if (keyword) {
        if (keyword && (keyword.indexOf('[') >= 0 || keyword.indexOf(']') >= 0)) {
          this.formData.keyword = undefined;
          return;
        }
        this.formData.keyword = keyword;
        setTimeout(() => {
          this.$get('/nhf-app/factoryRaw/pageWithOutSpecialTypeIdFilterRight', {
            current: 1,
            size: 100,
            factoryId: window.localStorage.getItem('factoryId'),
            keyword
          }).then(res => {
            let { success, data } = res;
            if (success) {
              let { records } = data;
              records.map(el => {
                let nameArr = el.name.split(keyword);
                el.firstName = nameArr[0];
                el.lastName = nameArr[1];
                el.midName = keyword;
                return el;
              });
              this.searchList = records || [];
            }
          }).catch(() => {
            this.searchList = [];
          });
        }, 300);
      }
    },
    changeType(value) {
      if (value && value.length > 0) {
        this.formData.typeId = value[value.length - 1];
      } else {
        this.formData.typeId = undefined;
      }
      this.getList({ current: 1, pageSize: this.pagination.pageSize });
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.$emit('getTypeList', { targetOption, id: targetOption.id });
        // this.getTypeList(targetOption.id,targetOption) || []
        // this.typeList = [...this.typeList];
      }, 0);
    },
    onSearch() {
      this.getList({ current: 1, pageSize: this.pagination.pageSize, val: this.formData.keyword });
    },
    storageWeightCondChange(value){
      this.storageWeightCond = value.target.checked;
      this.$nextTick(()=>{
        this.getList()
      })
    },
    getList(pagination) {
      let { current = 1, pageSize = 20, val } = pagination || this.pagination;
      let factoryId = window.localStorage.getItem('factoryId');
      let params = {
        ...this.formData,
        current,
        size: pageSize,
        factoryId,
        status: this.status,
        storageWeightCond: this.storageWeightCond
      };
      if (this.keyword) {
        params.keyword = this.keyword;
      }
      if (val) {
        params.keyword = pagination.val;
      }
      this.$http.get('/nhf-app/factoryRaw/pageWithOutSpecialTypeIdFilterRight', { params }).then(res => {
        let { success, data } = res;
        if (success) {
          let { records, current = 1, total = 0 } = data;
          this.pagination.current = current;
          this.pagination.total = total;
          this.list = records || [];
        } else {
          this.$message.error('查询失败');
        }
      });
    },
    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },
    searchInput() {
      console.log('玉米皮');
      if (this.debounce) {
        this.debounce();
      } else {
        this.debounce = _.debounce(this.onSearch, 600);
        this.debounce();
      }
    },

    turnoverDayTip(record) {
      //purchaseClassCode 1001: 大料，其余为小料
      if ((record.purchaseClassCode === '1001' && record.turnoverDay > 15)
        || (record.purchaseClassCode !== '1001' && record.turnoverDay > 30)) {
        return true;
      }
    },
  }
};
</script>
<style lang="scss">
.productSelect .ant-select-selection__clear {
  right: 20px;
}
</style>
<style lang="scss" scoped>
.nurientHead {
  display: flex;

  .left,
  .right {
    width: 40%;
    // display: flex;
  }

  .right {
    text-align: right;
  }

  .middle {
    width: 20%;
  }
}

.tableBox {
  padding: 0;
  margin-top: 20px;
  // max-height: 500px;
  // overflow-y: auto;
}
</style>
